<template>
    <div class="voce-decide-tarja">
      <div class="voce-decide-tarja__shift" :style="cardStyle">
        <svg class="voce-decide-tarja__art" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid meet">
            <defs>
                <!-- Body gradient (lower/larger parallelogram, holds the text) -->
                <linearGradient id="voce-decide-body" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stop-color="#003D72" />
                    <stop offset="100%" stop-color="#002749" />
                </linearGradient>

                <!-- Header gradient (upper/smaller parallelogram, holds the name) -->
                <linearGradient id="voce-decide-header" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0%" stop-color="#C50000" />
                    <stop offset="100%" stop-color="#DC4D4A" />
                </linearGradient>

            </defs>

            <!-- Body (text) — top edge raised to tuck under the header (drawn on top), closing the seam -->
            <polygon points="57,868, 1260,868 1212,1018 9,1018" fill="url(#voce-decide-body)" stroke-width="1" stroke-linejoin="round" />
            <!-- Side triangle — solid, darker than the header -->
            <polygon points="21,868 58,868 38,930" fill="#780505" stroke-width="1" stroke-linejoin="round" />
            <!-- Header (name) -->
            <polygon points="46,788 639,788 614,868 21,868" fill="url(#voce-decide-header)" stroke-width="1" stroke-linejoin="round" />
        </svg>

        <!-- Collaborator name — over the header parallelogram -->
        <div class="voce-decide-tarja__name">
            <span>{{ colabData?.dsc_nome_colaborador }}</span>
        </div>

        <!-- Collaboration text — over the body parallelogram -->
        <div class="voce-decide-tarja__text">
            <span :style="{ fontSize: textFontSize }">{{ colabData.dsc_texto_colaboracao }}</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        colabData: Object,
        posicaoCard: String,
    },
    computed: {
        cardStyle() {
            if (this.posicaoCard === "centro") return { transform: "translateX(17%)" };
            if (this.posicaoCard === "direita") return { transform: "translateX(31%)" };
            return {};
        },
        textFontSize() {
            const len = (this.colabData?.dsc_texto_colaboracao || "").trim().length;
            if (len <= 60) return "1.9vw";
            if (len <= 120) return "1.6vw";
            if (len <= 180) return "1.35vw";
            if (len <= 240) return "1.15vw";
            return "1vw";
        },
    },
};
</script>

<style lang="scss" scoped>
.voce-decide-tarja {
    position: relative;
    width: 100%;
    height: 100vh; /* cap to viewport so the full-frame art never overflows (kills the scrollbar) */
    overflow: hidden; /* clip the transparent overflow + the horizontal posicaoCard shift */
}

.voce-decide-tarja__shift {
    position: absolute;
    left: 0;
    bottom: 0; /* anchor the art to the bottom; excess height is clipped off the top */
    width: 100%;
}

.voce-decide-tarja__art {
    display: block;
    width: 100%;
    height: auto;
    shape-rendering: geometricPrecision;
}

/* Name — over the header parallelogram */
.voce-decide-tarja__name {
    position: absolute;
    left: 4%;
    top: 73%;
    width: 27%;
    height: 7%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.voce-decide-tarja__name span {
    max-width: 100%;
    color: #ffffff;
    font-weight: 800;
    font-size: 2.1vw;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Collaboration text — over the body parallelogram */
.voce-decide-tarja__text {
    position: absolute;
    left: 4%;
    top: 81%;
    width: 60%;
    height: 13%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
}

.voce-decide-tarja__text span {
    color: #ffffff;
    font-weight: 800;
    line-height: 1.25;
    overflow-wrap: anywhere;
}
</style>
